import React from "react";
import { Shield, CheckCircle2 } from "lucide-react";

export const Guarantee = () => {
  return (
    <section id="guarantee" className="py-14 lg:py-28 blueprint-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-primary border-2 border-primary rounded-md overflow-hidden" style={{boxShadow: '6px 6px 0px rgba(249, 115, 22, 0.3)'}}>
            {/* Header */}
            <div className="bg-primary/90 px-8 py-6 flex items-center gap-4 border-b border-white/10">
              <div className="w-14 h-14 rounded-md bg-white/10 flex items-center justify-center">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <div>
                <p className="section-label text-accent mb-1">0 risque</p>
                <h2 className="text-2xl sm:text-3xl font-black text-white">
                  Notre garantie résultat
                </h2>
              </div>
            </div>

            {/* Content */}
            <div className="p-8 lg:p-10 bg-white">
              {/* Guarantee Statement */}
              <div className="text-center mb-8">
                <p className="text-lg sm:text-xl lg:text-2xl text-slate-900 leading-relaxed">
                  Si vous n'obtenez pas au moins{" "}
                  <strong className="text-accent">3 devis qualifiés en 30 jours</strong>,
                  on vous accompagne gratuitement jusqu'au résultat.
                </p>
              </div>

              {/* What This Means */}
              <div className="grid sm:grid-cols-2 gap-4">
                {[
                  "Aucun risque pour vous",
                  "On est motivés par votre succès",
                  "Pas de résultat = pas de facture prolongée",
                  "On reste jusqu'à ce que ça marche",
                ].map((item, index) => (
                  <div key={item} className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-md p-4">
                    <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0" />
                    <span className="text-slate-700 font-medium">{item}</span>
                  </div>
                ))}
              </div>

              {/* Trust Note */}
              <p className="text-sm text-slate-500 text-center mt-8">
                Notre business repose sur vos résultats. Si vous ne gagnez pas, on ne gagne pas non plus.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guarantee;
